import { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import { OnboardingModal } from "../../pages/EmailVerification/partials/OnboardingModal";
import { Header } from "../Header";
import { Sidebar } from "../Sidebar";
import { SellerCentralModal } from "../../components";

export const Main = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setIsMenuOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setIsMenuOpen((prev) => !prev);
    }
  };

  return (
    <>
      <CssBaseline />
      <Header onBurgerClick={handleDrawerToggle} />
      <Sidebar
        isOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        handleDrawerTransitionEnd={handleDrawerTransitionEnd}
        handleDrawerClose={handleDrawerClose}
      />
      <Box
        component="main"
        p={{ xs: "82px 4px 4px", md: "82px 12px 12px 70px" }}
      >
        <Outlet />
      </Box>
      <SellerCentralModal />
      <OnboardingModal />
    </>
  );
};

export default Main;
